import { Info, PricingPlans } from "./sections";

export const PricingPage = () => {
  return (
    <div className="flex flex-col gap-y-16">
      <Info />

      <PricingPlans />
    </div>
  );
};
